module.exports = __webpack_public_path__ + "img/badge100.8cd93ed8.png";